module.exports = __webpack_public_path__ + "img/single-storey-houses-1.0f195cc0.jpg";